import { render, staticRenderFns } from "./AgendaView.vue?vue&type=template&id=8e50e516"
import script from "./AgendaView.vue?vue&type=script&lang=js"
export * from "./AgendaView.vue?vue&type=script&lang=js"
import style0 from "./AgendaView.vue?vue&type=style&index=0&id=8e50e516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports